import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { GetProviderInternalOrClientContacts } from "../../../../../../../actions/client-portal/AllContactsApi";
import ContactsList from "./ContactsList";
import { decryptId } from "../../../../../../../common/encryptDecrypt/encryptdecrypt";
import { debounce } from "../../../../../../../common/snippet/Debouncing";
import useUnauthorizedHandler from "../../../../../../../common/snippet/useUnauthorizedHandler";
import { Pagination } from "../../../../../../../common/pagination";

const Contacts = () => {
    const dispatch = useDispatch();
    const {organisationId}=useParams()
    const handleUnauthorizedAccess = useUnauthorizedHandler();
    const [filterpage, setfilterpage] = useState(1);
    const [filterlimit, setfilterlimit] = useState(10);
    const [countData, setCountData] = useState(0);
    const [searchTerm, setsearchTerm] = useState("");
    const [totalPages, setTotalPages] = useState(1);
    const [filtersort, setFiltersort] = useState("contact_first_name");
    const [filterorder, setFilterOrder] = useState("desc");
    const [DocData, setDocData] = useState("");
    const userData = JSON.parse(localStorage.getItem("LoginUserData"));
    const handleSeachChange = (e) => {
        setsearchTerm(e.target.value.trim());
        setfilterpage(1);
    };
    const inputchangeSearch = useCallback(debounce(handleSeachChange), []);

    const handlePageChange = ({ selected }) => {
        setfilterpage(selected + 1);
        GetProviderInternalOrClientContacts(selected + 1, filterlimit);
    
    };
    const handleSort = (sortType) => {
        setFiltersort(sortType);
        setFilterOrder(filterorder === "asc" ? "desc" : "asc");
    };

    const OnGetProviderInternalOrClientContacts = useCallback(async () => {
        const payload = {
            sort: filtersort,
            order: filterorder,
            page: filterpage,
            limit: filterlimit,
            search: searchTerm,
            organisation_id:  decryptId(organisationId),
            type:"clientContact",
            client_org_id: userData?.organisation_id ? userData?.organisation_id:""
        }
        try {
            const response = await dispatch(GetProviderInternalOrClientContacts(payload));
            const { success, data, status } = response;
            if (success) {
                const { rows } = data;
                setCountData(response?.data?.count);
                setDocData(rows);
                setTotalPages(Math.ceil(response?.data?.count / filterlimit));
                
            } else if (status === 401) {
                handleUnauthorizedAccess();
            } else {
                console.error('Failed to fetch compliance checklist:', response);
                // Handle other types of errors or unsuccessful responses
            }
        } catch (error) {
            console.error('Failed to fetch compliance checklist:', error);
            // Handle unexpected errors
        }
    }, [
        dispatch,
        filtersort,
        filterorder,
        searchTerm,
        filterlimit,
        filterpage,
    ]);

    useEffect(() => {
      OnGetProviderInternalOrClientContacts();
    }, [
        filtersort,
        filterorder,
        searchTerm,
        filterlimit,
        filterpage,
    ]);
    return (
        <React.Fragment>
            <div className="flex justify-between mb-5 px-2">
                <div className="w-80 h-10">
                    <div className="input-wrapper">
                        <div className='input-suffix-start left-3.5'>
                            <img src="/assets/icons-svg/search-lg.svg" alt="" className="h-5" />
                        </div>
                        <input
                            type="text"
                            name="hs-table-search"
                            className="input  pl-11 w-full  input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border  text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            placeholder="Search"
                            onChange={(e) => inputchangeSearch(e)}
                        />
                    </div>
                </div>
            </div>
            <ContactsList
                handleSort={handleSort}
                filtersort={filtersort}
                filterorder={filterorder}
                allListData={DocData}
            />

            <div className="flex justify-between mt-3">
                <Pagination
                    totalCount={countData}
                    pageNumber={filterpage}
                    displayPage={DocData?.length}
                    UpdatePageLimit={setfilterlimit}
                    UpdatePage={setfilterpage}
                />
                {countData > 0 && <ReactPaginate
                    className="flex justify-content-end p-2 align-items-center pagination-wrap"
                    previousLabel={"Prev"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    previousLinkClassName={"prev-link"}
                    nextLinkClassName={"page-link"}
                    breakLinkClassName={"prev-link"}
                    previousClassname={"px-4 rounded-md bg-blue-700 text-white"}
                    nextClassname={"px-4 rounded-md bg-blue-700 text-white"}
                    pageLinkClassName={"px-4 rounded-md"}
                    activeLinkClassName={"w-9 h-9 bg-blue-700 text-white"}
                    disabledClassName={"px-5 opacity-50 cursor-not-allowed"}
                    renderOnZeroPageCount={null}
                    forcePage={filterpage - 1}
                />}
            </div>
        </React.Fragment>
    )
}
export default Contacts
